/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CargoInputs */

const en_cargo = /** @type {(inputs: CargoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargo`)
};

const es_cargo = /** @type {(inputs: CargoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

/**
* | output |
* | --- |
* | "Cargo" |
*
* @param {CargoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo = /** @type {((inputs?: CargoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CargoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo(inputs)
	return es_cargo(inputs)
});